<template>
    <div class="container-fluid">
        <v-title :breadcrumb="{label: 'Invoices', route: {name: 'invoices'}, root: true}">
            Invoices
        </v-title>
        <div class="grid flex-flow-column">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :provider="provider"
                    @completed="stopLoadingPage"
                    :tabs="gridTabs"
                    :filter-set="gridFilterSet"
                >
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no invoices</span>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import invoiceFilters from '@/common/query/filter/invoice-filters';
    import invoiceColumns from './invoice-columns';
    import invoiceModel from '@/common/models/invoice-model';
    import FilterSet from '@/components/query/filter-set';

    export default {
        name: 'invoices',
        components: {
            vTitle,
            vNoContent,
            Grid,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: invoiceColumns,
                gridTabs: new TabsConfiguration({
                    id: 'invoice-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {issuedTime: 'desc'},
                        },
                        {
                            label: 'Past Due',
                            sortBy: {issuedTime: 'desc'},
                            filter: [['status', [invoiceModel.Status.pastDue]]],
                        },
                        {
                            label: 'Abandoned',
                            sortBy: {issuedTime: 'desc'},
                            filter: [['status', [invoiceModel.Status.abandoned]]],
                        },
                        {
                            label: 'Refunded',
                            sortBy: {issuedTime: 'desc'},
                            filter: [['status', [invoiceModel.Status.refunded]]],
                        },
                    ],
                    version: 1,
                    filtersVersion: invoiceFilters.version,
                }),
                gridFilterSet: new FilterSet({store: this.$store, ...invoiceFilters}),
            };
        },
        methods: {
            provider(params) {
                return this.$api(({invoices}) => invoices.getAll(params));
            },
        },
    };
</script>
